import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

import { BRAND_PALETTE } from './constant/theme.constant';

// The logo's blue, coloured as the account app colours its own: light mode puts white on 600,
// dark mode dark text on 400.
export const AiArcsPreset = definePreset(Aura, {
    semantic: {
        primary: {
            ...BRAND_PALETTE,
            color: 'light-dark({primary.600}, {primary.400})',
            contrastColor: 'light-dark(#ffffff, {surface.900})',
            hoverColor: 'light-dark({primary.700}, {primary.300})',
            activeColor: 'light-dark({primary.800}, {primary.200})',
        },
    },
    // PrimeNG 22 packs tables tighter than 21; these are 21's roomier sizes.
    components: {
        datatable: {
            header: { padding: '0.75rem 1rem' },
            headerCell: { padding: '0.75rem 1rem' },
            bodyCell: { padding: '0.75rem 1rem', fontSize: '1rem' },
        },
    },
});
